import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, useTheme, InputBase, IconButton, Grid, Typography, Divider } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SearchIcon from "@mui/icons-material/Search";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import { useEffect, useState } from "react";
import "./Sidebar.css"
import { useSelector } from "react-redux";
import UserSessionModal from "../../components/Global/UserSessionModal/UserSessionModal";

const Item = ({ title, to, icon, selected, setSelected, isCollapsed, onClick }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleClick = () => {
    setSelected(title);
  };

  const isSelected = selected === title;

  return (
    <div onClick={handleClick} style={{ position: "relative" }}>
      <MenuItem
        active={isSelected}
        className={`sidebar-item ${isSelected ? 'selected' : ''}`}
        style={{
          height: "38px",
          width: "auto",
          padding: "0 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          transition: "all 0.3s ease",
          backgroundColor: !isSelected ? colors.grey[700] : "transparent",
        }}
        onClick={onClick}
      >
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "40px" }}>
            {icon}
          </Box>
          <Box sx={{
            display: "flex", justifyContent: "flex-start", alignItems: "left", width: "auto"
          }}>
            <Typography sx={{ fontWeight: "600", fontSize: "14px" }}>{title}</Typography>
          </Box>
        </Box>
        <Link to={to} style={{ position: "absolute", top: 0, bottom: 0, left: 0, right: 0 }} />
      </MenuItem>
    </div>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [searchQuery, setSearchQuery] = useState("");
  const location = useLocation();
  const [selected, setSelected] = useState('Dashboard');
  const user = useSelector((state) => (state.User));
  const [showUserModal, setShowUserModal] = useState(false);
  const [currentUser, setCurrentUser] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("currentUser");
    if (storedUser) {
      setCurrentUser(storedUser);
    }
  }, []);

  const handleChangeUser = () => {
    setShowUserModal(true);
  };

  const handleUserSelection = (userName) => {
    setCurrentUser(userName);
    setShowUserModal(false);
  };

  const handleSearchInputChange = (event) => setSearchQuery(event.target.value);

  const menuItems = [];

  menuItems.push(
    { to: "/", text: "Dashboard", Icon: SpaceDashboardIcon },
  );


  return (
    <Box sx={{
      "& .pro-sidebar-inner": {
        background: `${colors.grey[900]} !important`,
      },
      "& .pro-icon-wrapper": {
        backgroundColor: "transparent !important",
      },
      "& .pro-inner-item": {
        padding: "5px 35px 5px 20px !important",
      },
      "& .logo-menu-item:hover": {
        border: "none !important",
      },
      "& .pro-menu-item.active": {
        border: "none !important",
      },
      height: "100vh",
      transition: "width 0.3s",
      boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px"
    }}>
      <ProSidebar>
        <Menu iconShape="square">
          <Box display="flex" justifyContent="center" alignItems="center" padding={"5px"} marginTop={"20px"}>
            <img src="/principal.png" alt="title" style={{ width: "75%", height: "auto", display: "block", marginBottom: "30px" }} />
          </Box>

          {/* Search Input */}
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Box
              display="flex"
              backgroundColor={colors.grey[700]}
              borderRadius="10px"
              sx={{
                width: "90%",
                height: "40px",
                marginBottom: "20px"
              }}
            >
              <InputBase
                sx={{
                  ml: 2,
                  flex: 1,
                  color: "#ffffff",
                  "& input::placeholder": { color: "white", opacity: 1 },
                }}
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearchInputChange}
              />
              <IconButton type="button" sx={{ p: 2, color: "#ffffff" }}>
                <SearchIcon />
              </IconButton>
            </Box>
          </Box>
          {menuItems.map(({ to, text, Icon }) => (
            <Item key={to} title={text} to={to} icon={<Icon />} selected={selected} setSelected={setSelected} />
          ))}
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <Divider sx={{ bgcolor: colors.grey[600], width: "90%", mt: "10px", mb: "10px" }} />
          </Box>
          
          {/* Usuario actual */}
          {currentUser && (
            <Box sx={{ px: 2, py: 1, mb: 1 }}>
              <Typography variant="caption" color="text.secondary">
                Usuario actual:
              </Typography>
              <Typography variant="body2" fontWeight="bold" color="primary">
                {currentUser}
              </Typography>
            </Box>
          )}
          
          <Item 
            title="Cambiar Usuario" 
            to="#" 
            icon={<SwitchAccountIcon />} 
            selected={selected} 
            setSelected={setSelected}
            onClick={(e) => {
              e.preventDefault();
              handleChangeUser();
            }}
          />
          <Item title="Log Out" to="/" icon={<ExitToAppIcon />} selected={selected} setSelected={setSelected} />
        </Menu>
      </ProSidebar>
      <UserSessionModal open={showUserModal} onSelectUser={handleUserSelection} />
    </Box>
  );
};

export default Sidebar;
